import { stringCompare } from '../utils/trainUtils';
import find from "lodash/fp/find";
import isEqual from "lodash/fp/isEqual";
import values from "lodash/fp/values";
import defaultTo from "lodash/fp/defaultTo";

export const Classes = Object.freeze({
  AllClasses: {
    code: '',
    value: 'All Classes',
  },
  OneA: {
    code: '1A',
    value: '1st Class AC',
  },
  TwoA: {
    code: '2A',
    value: '2 Tier AC',
  },
  ThreeA: {
    code: '3A',
    value: '3 Tier AC',
  },
  SL: {
    code: 'SL',
    value: 'Sleeper',
  },
  EV: {
    code: 'EV',
    value: 'Vistadome AC',
  },
  TwoS: {
    code: '2S',
    value: 'Second Sitting',
  },
  CC: {
    code: 'CC',
    value: 'AC Chair Car',
  },
  EA: {
    code: 'EA',
    value: 'Executive Anubhuti',

  },
  FC: {
    code: 'FC',
    value: 'First Class',
  },
  ThreeE: {
    code: '3E',
    value: 'AC three tier(economy)',
  },
  EC: {
    code: 'EC',
    value: 'Executive Chair Car',
  },
  URGN: {
    code: 'UR/GEN',
    value: 'Unreserved/General',
  },
});

export const AcClasses = {
  '1A': 'AC', '2A': 'AC', '3A': 'AC', CC: 'AC', EA: 'AC', EC: 'AC',
};

export const getClassType = (value) => {
  return defaultTo(
    {
      code: value,
      value,
    },
    find((classType) => isEqual(classType.code, value))(values(Classes))
  );
}

export const availability = {
  '1': 'CNF',
  '2': 'RAC',
  types: [ '1', '2' ],
};